import {type ReactNode} from 'react'
import {HgAspectRatio} from '~/design-system/hg/components'
import {cn} from '~/design-system/utils'
import {tv, type VariantProps} from 'tailwind-variants'
import {type OmitStrict} from 'type-zoo'

const mediaAsset = tv({
  slots: {
    wrapper: '',
    caption: '',
  },
  variants: {
    size: {
      xs: {
        wrapper:
          'col-span-10 col-start-2 md:col-span-6 md:col-start-4 lg:col-start-6',
      },
      small: {wrapper: 'col-span-full md:col-span-8 md:col-start-3 lg:col-start-5'},
      medium: {wrapper: 'col-span-full lg:col-span-12 lg:col-start-3'},
      large: {wrapper: 'col-span-full'},
      xl: {
        caption: 'px-s5',
        wrapper:
          '-mx-s5 w-screen [@media_(min-width:_var(--grid-max-width))]:mx-[calc(-100vw_/_2_+_var(--grid-max-width)_/_2_-32px)]',
      },
    },
  },
})

type HgMediaAssetProps = {
  asset: ReactNode
  caption: ReactNode
  credit?: ReactNode
  classNames?: {
    wrapper?: string
    caption?: string
  }
}

export type HgArticleWYSIWYGMediaAssetProps = OmitStrict<
  HgMediaAssetProps,
  'classNames'
> &
  NonNullable<VariantProps<typeof mediaAsset>>

export const HgMediaAsset = ({
  asset,
  caption,
  credit,
  classNames,
}: HgMediaAssetProps) => {
  return (
    <figure className={cn('flex flex-col space-y-s2', classNames?.wrapper)}>
      <HgAspectRatio aspectRatio="none" classNames={{assetWrapper: 'rounded-none'}}>
        {asset}
      </HgAspectRatio>
      {(caption || credit) && (
        <figcaption
          className={cn(
            'flex flex-row flex-wrap justify-between gap-s1 text-text-emphasized arcadia-body-3',
            classNames?.caption
          )}
        >
          {caption}
          {credit && <span className="text-text-subdued">{credit}</span>}
        </figcaption>
      )}
    </figure>
  )
}

export const HgArticleWYSIWYGMediaAsset = (
  props: HgArticleWYSIWYGMediaAssetProps
) => {
  const {wrapper, caption} = mediaAsset({size: props.size})
  return (
    <HgMediaAsset {...props} classNames={{wrapper: wrapper(), caption: caption()}} />
  )
}
